import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { APP_USERS, CHANGE_USER_PASS } from '../models/User';
import * as Globals from '../globals';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css']
})
export class UserProfileComponent implements OnInit {
  userProfile: any;
  user: APP_USERS;
  userChange: CHANGE_USER_PASS;
  loading: boolean;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService) {
    this.toastr.setRootViewContainerRef(vRef);
    this.userProfile = { PARENT_GROUP_ID: null };
  }
  ngOnInit() {
    this.user = new APP_USERS(0, null, null, '', null, null, null, null, null, null, null, null, null);
    this.userChange = new CHANGE_USER_PASS('', '', '');
    this.profileService.getProfileInfo();
    if (!this.profileService.userProfile) {
      this.profileService.signOut();
    } else {
      this.subInit();
    }
  }
  subInit() {
    this.userProfile = this.profileService.userProfile;
    this.getUser();
  }
  getUser() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/user?id=' + this.userProfile.USER_ID + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        console.log(this.userProfile.USER_ID);
        this.user = res.json();
        this.user.PASSWORD = '';
        this.user.REPASSWORD = '';
        var date = new Date(this.user.SD_EXPIRY);
        this.user.D_EXPIRY = date;
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  Save() {
    this.loading = true;
    this.http.put(Globals.serviceUrl + 'ref/changepassword?id=' + this.userProfile.USER_ID, this.userChange, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.loading = false;
        this.toastr.success('Password berhasil diubah.');
        this.userChange = new CHANGE_USER_PASS('', '', '');
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  logOut() {
    sessionStorage.removeItem('authorizationData');
    sessionStorage.removeItem('userProfile');
    location.href = '';
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/user-profile/user-profile.component.ts